// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksBeneficialResponse implements flatbuffers.IUnpackableObject<AllBanksBeneficialResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksBeneficialResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksBeneficialResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksBeneficialResponse,
  ): AllBanksBeneficialResponse {
    return (obj || new AllBanksBeneficialResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksBeneficialResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksBeneficialResponse,
  ): AllBanksBeneficialResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksBeneficialResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  bankName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  liftName(): string;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  floorName(): string | null;
  floorName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floorName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  duration(): string;
  duration(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  duration(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  message(): string;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  message(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  seconds(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksBeneficialResponse(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addFloorName(builder: flatbuffers.Builder, floorNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, floorNameOffset, 0);
  }

  static addDuration(builder: flatbuffers.Builder, durationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, durationOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, dateOffset, 0);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, messageOffset, 0);
  }

  static addSeconds(builder: flatbuffers.Builder, seconds: bigint) {
    builder.addFieldInt64(6, seconds, 0n);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(7, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(8, liftId, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(9, position, 0);
  }

  static endAllBanksBeneficialResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_name
    builder.requiredField(offset, 6); // lift_name
    builder.requiredField(offset, 10); // duration
    builder.requiredField(offset, 12); // date
    builder.requiredField(offset, 14); // message
    return offset;
  }

  static createAllBanksBeneficialResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    floorNameOffset: flatbuffers.Offset,
    durationOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    messageOffset: flatbuffers.Offset,
    seconds: bigint,
    bankId: number,
    liftId: number,
    position: number,
  ): flatbuffers.Offset {
    AllBanksBeneficialResponse.startAllBanksBeneficialResponse(builder);
    AllBanksBeneficialResponse.addBankName(builder, bankNameOffset);
    AllBanksBeneficialResponse.addLiftName(builder, liftNameOffset);
    AllBanksBeneficialResponse.addFloorName(builder, floorNameOffset);
    AllBanksBeneficialResponse.addDuration(builder, durationOffset);
    AllBanksBeneficialResponse.addDate(builder, dateOffset);
    AllBanksBeneficialResponse.addMessage(builder, messageOffset);
    AllBanksBeneficialResponse.addSeconds(builder, seconds);
    AllBanksBeneficialResponse.addBankId(builder, bankId);
    AllBanksBeneficialResponse.addLiftId(builder, liftId);
    AllBanksBeneficialResponse.addPosition(builder, position);
    return AllBanksBeneficialResponse.endAllBanksBeneficialResponse(builder);
  }

  unpack(): AllBanksBeneficialResponseT {
    return new AllBanksBeneficialResponseT(
      this.bankName(),
      this.liftName(),
      this.floorName(),
      this.duration(),
      this.date(),
      this.message(),
      this.seconds(),
      this.bankId(),
      this.liftId(),
      this.position(),
    );
  }

  unpackTo(_o: AllBanksBeneficialResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.floorName = this.floorName();
    _o.duration = this.duration();
    _o.date = this.date();
    _o.message = this.message();
    _o.seconds = this.seconds();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
    _o.position = this.position();
  }

  unpackFields(...fields: string[]): AllBanksBeneficialResponseT {
    const t = new AllBanksBeneficialResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("floor_name")) {
      t.floorName = this.floorName();
    }
    if (fieldSet.has("duration")) {
      t.duration = this.duration();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("seconds")) {
      t.seconds = this.seconds();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    return t;
  }
}

export class AllBanksBeneficialResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public floorName: string | Uint8Array | null = null,
    public duration: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public message: string | Uint8Array | null = null,
    public seconds: bigint = 0n,
    public bankId: number = 0,
    public liftId: number = 0,
    public position: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankName === null || this.bankName === undefined) {
      throw new Error('Required field "bank_name" is not set');
    }
    if (this.liftName === null || this.liftName === undefined) {
      throw new Error('Required field "lift_name" is not set');
    }
    if (this.duration === null || this.duration === undefined) {
      throw new Error('Required field "duration" is not set');
    }
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const floorName = this.floorName !== null ? builder.createString(this.floorName!) : 0;
    const duration = this.duration !== null ? builder.createString(this.duration!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const message = this.message !== null ? builder.createString(this.message!) : 0;

    return AllBanksBeneficialResponse.createAllBanksBeneficialResponse(
      builder,
      bankName,
      liftName,
      floorName,
      duration,
      date,
      message,
      this.seconds,
      this.bankId,
      this.liftId,
      this.position,
    );
  }

  clone(): AllBanksBeneficialResponseT {
    const obj = new AllBanksBeneficialResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.floorName = this.floorName;
    obj.duration = this.duration;
    obj.date = this.date;
    obj.message = this.message;
    obj.seconds = this.seconds;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    obj.position = this.position;
    return obj;
  }

  equals(other: AllBanksBeneficialResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.floorName !== other.floorName) return false;
    if (this.duration !== other.duration) return false;
    if (this.date !== other.date) return false;
    if (this.message !== other.message) return false;
    if (this.seconds !== other.seconds) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    if (this.position !== other.position) return false;
    return true;
  }
}

export function verifyAllBanksBeneficialResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "lift_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "duration");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "message");
    verifier.checkScalarField(tablePos, 16, 8);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
    verifier.checkScalarField(tablePos, 22, 2);
  } finally {
    verifier.popDepth();
  }
}
